package com.evoapps.evoshift.session

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Singleton managing the globally selected workplace context. With a [store] the choice survives
 * restarts (DashboardViewModel falls back to the first workplace when it is no longer theirs);
 * signing out clears it.
 */
class WorkplaceSessionManager(private val store: LastWorkplaceStore? = null) {
    private val _currentWorkplaceId = MutableStateFlow(store?.load())
    val currentWorkplaceId: StateFlow<String?> = _currentWorkplaceId.asStateFlow()

    fun setWorkplaceId(id: String?) {
        _currentWorkplaceId.value = id
        store?.save(id)
    }
}
